import React from 'react';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import './LanguagePicker.css';

function LanguagePicker() {
  const { language, setLanguage } = useLanguage();
  const t = translations[language];

  return (
    <div className="language-picker">
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="language-select"
      >
        <option value="en">{t.english}</option>
        <option value="ta">{t.tamil}</option>
      </select>
    </div>
  );
}

export default LanguagePicker;
